import React, { useEffect } from 'react';

const DokumentacePage: React.FC = () => {
    useEffect(() => {
        window.location.href = 'https://wiki.hasicionline.cz';
    }, []);

    return null;
};

export default DokumentacePage;
